import { CacheTable, StorageTable } from './cache-table';

export class UserPreferences {

}

export class LocalPreferences {
  cookies: {
    accepted: string
  };
  user: UserPreferences;
}

export class CachePreferences extends StorageTable {
  constructor() {
    super('preferences', 'core');
  }

  get(key: string) {
    return this._get(key);
  }

  set(key: string, value: object) {
    return this._set(key, value);
  }


}
